export enum SpecialtyBehaviour {
  Primary = 1
}
